import { useState } from 'react';

export const useDrawer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleIsOpen = () => setIsOpen((isOpen) => !isOpen);
  const close = () => setIsOpen(false);

  return { isOpen, toggleIsOpen, close };
};
